import styled from "styled-components";

export type ErrorMessageProps = {
  errorMessage: string | undefined | null;
};
const ErrorMessageWrapper = styled.div`
  width: 300px;
  height: 15px;
  font-size: ${(props) => props.theme.fontSize.xsmall};
  line-height: 22px;
  color: ${(props) => props.theme.colors.caution};
`;

export const ErrorMessage = ({ errorMessage }: ErrorMessageProps) => (
  <ErrorMessageWrapper>{errorMessage || ""}</ErrorMessageWrapper>
);
